<template>

	<div id="container" ref="container">

		<slot name="video"></slot>

		<div id="articles" ref="articleWrap">

			<logo></logo>
			<button class="close-button" @click="quitEpisode()">
				<svg height="24px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg>
			</button>

			<slot name="components"></slot>

		</div>

	</div>

</template>

<script>

import Logo from './../common/Logo'

export default {

	components: {

		'logo': Logo

	},

	data() {

		return {

			scale: 1,

		}
	},

	mounted: function () {

		window.addEventListener('resize', this.resizeVideo);
		this.resizeVideo();
 	},

	beforeDestroy: function () {

		window.removeEventListener('resize', this.resizeVideo);

 	}, 	

 	methods: {

		resizeVideo() {
			console.log('resize')
			let maxWidth = this.$refs.articleWrap.offsetWidth,
			maxHeight = this.$refs.articleWrap.offsetHeight,
			width = window.innerWidth,
			height = window.innerHeight;    

			this.scale = Math.min(width/maxWidth, height/maxHeight);

			this.$refs.articleWrap.style.transform = 'scale(' + this.scale + ')';
			this.$refs.articleWrap.style.WebkitTransform = 'scale(' + this.scale + ')';
			this.$parent.$refs.video.setAttribute("style","");
			this.$refs.container.setAttribute("style","");

			let videoWidth = Math.round( maxWidth * this.scale ),
			videoHeight = Math.round( maxHeight * this.scale ),
			marginTop = Math.round( (height - ( maxHeight * this.scale )) / 2 ),
			marginLeft = Math.round( (width - videoWidth) / 2 );  

			this.$parent.$refs.video.style.width = videoWidth+"px";
			this.$parent.$refs.video.style.height = videoHeight+"px";

			if( height > videoHeight ) {

				this.$refs.container.style.marginTop =marginTop+"px";

			}

			if( videoWidth < width ) {

				this.$refs.container.style.marginLeft = marginLeft+"px";

			}

		},
		quitEpisode () {
			this.$router.push({ name: 'home' })
		}

	}
}

</script>

<style lang="scss" scoped>

#container {

	position: relative;
	overflow: hidden;
	height: 100%;

}

#articles {

	width: 1280px;
	height: 720px;
	transform-origin: top left;
	position: absolute;
	top: 0;
	left: 0px;
	z-index: 99;

}

.close-button {

	position: absolute;
	right: 20px;
	top: 10px;
	height: 60px;
	width: 60px;
	z-index: 99;
	background: transparent;
	border: 0;
	outline: 0;
	cursor: pointer;
	svg {
		fill: white;
	}

}

</style>



// WEBPACK FOOTER //
// Wrapper.vue?33d85b3c